import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-course-progress.tsx
var LazyCourseProgress = lazy(() => import("./course-progress-tjL8ELAZ.js").then((n) => n.n).then((module) => ({ default: module.CourseProgress })));
function CourseProgress({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-progress" }),
		children: /* @__PURE__ */ jsx(LazyCourseProgress, { ...props })
	});
}
function CourseProgressContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "course-progress" }),
		children: /* @__PURE__ */ jsx(LazyCourseProgress, { ...props })
	});
}
var useCourseProgressContent = () => {
	return useMemo(() => ({ courseProgress: { component: CourseProgressContent } }), []);
};
//#endregion
export { CourseProgress, useCourseProgressContent };
